module.exports = __webpack_public_path__ + "img/b.17443886.jpg";